var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-container"},[_c('b-form-input',{staticClass:"search",on:{"input":_vm.onInputChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }